<nav aria-label="breadcrumb">
  <ol class="breadcrumb">

    @for (breadcrumb of breadcrumbs$ | async;track breadcrumb; let isLast = $last) {

      <li class="breadcrumb-item" [ngClass]="{'active': isLast}">

        @if (!isLast) {

          <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>

        } @else {

          <span [innerText]="breadcrumb.label"></span>

        }

      </li>
      
    }

  </ol>
</nav>
